// extracted by mini-css-extract-plugin
module.exports = {"columnsWrapper":"columns_columnsWrapper__3hj7M","invert":"columns_invert__2cs7C","sideColumn":"columns_sideColumn__1_lD4","mainColumn":"columns_mainColumn__1g7pn"};